enum UPLOAD_KIND {
  UNDEFINED,
  HYPES_IMAGE = 19,
  HYPES_VIDEO = 20
}

export default UPLOAD_KIND
